import React, { useId } from 'react'

/**
 * Brand Voice: a speech bubble with three bars knocked out of it. The bars are a real
 * cutout, so whatever sits behind the icon shows through them.
 *
 * The mask needs an id of its own per instance. A fixed id would make every copy on a
 * page point at the first one's mask, and the cutout would vanish with it.
 */
const BrandVoiceFilled = React.memo((props: { className?: string }) => {
    const maskId = `brand-voice-knock-${useId().replace(/:/g, '')}`

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={props.className}
            viewBox="0 0 24 24"
            data-icon="brand-voice"
            height="1em"
            width="1em"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            overflow="visible"
            aria-hidden="true"
        >
            <defs>
                <mask id={maskId} maskUnits="userSpaceOnUse" x="-8" y="-8" width="40" height="40">
                    <rect x="-8" y="-8" width="40" height="40" fill="#fff" stroke="none" />
                    <g stroke="#000">
                        <path d="M9 8.5v3" />
                        <path d="M12 7.5v5" />
                        <path d="M15 9v2" />
                    </g>
                </mask>
            </defs>
            <g mask={`url(#${maskId})`} fill="currentColor">
                <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v9a1.5 1.5 0 0 1-1.5 1.5H11l-4 3.5V16H5.5A1.5 1.5 0 0 1 4 14.5z" />
            </g>
        </svg>
    )
})

export default BrandVoiceFilled
